import React, { Component } from "react";
import { connect } from "react-redux";
import { getRawValue } from "../../utils/misc";


class _TopScrollBar extends Component {


    shouldHideScrollBar() {

        const { registerTableWidth, registerTableScrollWrapperWidth, tableHeaderIsFixed } = this.props;

        if (tableHeaderIsFixed) {
            return true;
        }

        if (getRawValue(registerTableWidth) <= getRawValue(registerTableScrollWrapperWidth)) {
            return true;
        }

        return false;

    }


    render() {

        const { registerTableWidth, registerTableScrollWrapperWidth } = this.props;

        return (
            <div
                className={`wrapper--registers register-top-scroll-bar-outside-wrapper u-hidden-small ${this.shouldHideScrollBar() ? "u-hidden" : ""}`}
            >
                <div
                    className="u-flex table-scroll register-top-scroll-bar-wrapper"
                    style={{ width: registerTableScrollWrapperWidth }}
                    id="register-top-scroll-bar-wrapper"
                >
                    <div className="u-flex-grow u-pr--xsmall ">
                        <div
                            id="register-top-scroll-bar"
                            style={{ minWidth: registerTableWidth }}
                            className="u-overflow-unset register-top-scroll-bar"
                        >
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    registerTableWidth: state.mutableInterface.registerTableWidth,
    registerTableScrollWrapperWidth: state.mutableInterface.registerTableScrollWrapperWidth,
    tableHeaderIsFixed: state.mutableInterface.tableHeaderIsFixed,
});

export const TopScrollBar = connect(mapStateToProps)(_TopScrollBar);
